import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a97ba0dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prefix" }
const _hoisted_2 = ["disabled", "value", "placeholder"]
const _hoisted_3 = { class: "suffix" }

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
    value: {},
    disabled: { type: Boolean, default: false },
    placeholder: { default: '' }
  },
  emits: ["update:value", "input", "change", "blur", "focus", "enter"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emit = __emit

const focused = ref(false)

const handleInput = (e: Event) => {
  emit('update:value', (e.target as HTMLInputElement).value)
}
const handleBlur = (e: Event) => {
  focused.value = false
  emit('blur', e)
}
const handleFocus = (e: Event) => {
  focused.value = true
  emit('focus', e)
}

const inputRef = ref<HTMLInputElement>()
const focus = () => {
  if (inputRef.value) inputRef.value.focus()
}

__expose({
  focus,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input", {
      'disabled': _ctx.disabled,
      'focused': focused.value,
    }])
  }, [
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "prefix")
    ]),
    _createElementVNode("input", {
      type: "text",
      ref_key: "inputRef",
      ref: inputRef,
      disabled: _ctx.disabled,
      value: _ctx.value,
      placeholder: _ctx.placeholder,
      onInput: _cache[0] || (_cache[0] = $event => handleInput($event)),
      onFocus: _cache[1] || (_cache[1] = $event => handleFocus($event)),
      onBlur: _cache[2] || (_cache[2] = $event => handleBlur($event)),
      onChange: _cache[3] || (_cache[3] = $event => emit('change', $event)),
      onKeydown: _cache[4] || (_cache[4] = _withKeys($event => emit('enter', $event), ["enter"]))
    }, null, 40, _hoisted_2),
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "suffix")
    ])
  ], 2))
}
}

})